import { matchRoutes, useLocation } from "react-router-dom";

const useCurrentPath = () => {
	const location = useLocation();

	const getCurrentPath = () => {
		const routes = [
			{ path: "dashboard" },
			{ path: "OldDashboard" },
			{ path: "alerts" },
			{ path: "vehicleHealth" },
			{ path: "notifications" },
			{ path: "recurrence" },
			{ path: "downtime" },
			{ path: "details/:assetId" },
			{ path: "detailsHealth/:assetId" },
		];
		const match = matchRoutes(routes, location);

		if (!match) {
			return null;
		}

		const [{ route }] = match;

		return route.path;
	};

	return getCurrentPath();
};

export default useCurrentPath;
